import { render } from "./VTextField.vue?vue&type=template&id=11d1a550"
import script from "./VTextField.vue?vue&type=script&lang=js"
export * from "./VTextField.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__